import React from "react";
import {
  Chip,
  Grid,
  Divider
} from "@mui/material";
import {SectionInput} from "../../../../products/Product/components/MainInfo";

class SeoMeta extends React.PureComponent {

  onChangForm = (locale, name, value) => {
    let values = {...this.props.values};
    values[locale][name] = value;
    this.props.onChange(values);
  }

  render () {
    const {
      values
    } = this.props;

    return (
      <Grid container spacing={1}>

        {/* RU */}
        <Grid item xs={12}>
          <Grid container alignItems="flex-end">
            <Grid item>
              <Chip label="RU"/>
            </Grid>
            <Grid item sx={{flex: 1}}>
              <Divider sx={{borderBottomWidth: "2px", borderColor: "rgba(0,0,0,0.08)"}}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Title"
            value={values['ru']['meta_title']}
            onChange={this.onChangForm.bind(this, 'ru', 'meta_title')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Keywords"
            value={values['ru']['meta_keywords']}
            onChange={this.onChangForm.bind(this, 'ru', 'meta_keywords')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Description"
            value={values['ru']['meta_description']}
            onChange={this.onChangForm.bind(this, 'ru', 'meta_description')}
          />
        </Grid>

        <Grid item xs={12}>
          <SectionInput
            title="SEO text short"
            value={values['ru']['seo_text_short']}
            onChange={this.onChangForm.bind(this, 'ru', 'seo_text_short')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO text full"
            value={values['ru']['seo_text_full']}
            onChange={this.onChangForm.bind(this, 'ru', 'seo_text_full')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="META title sold"
            value={values['ru']['meta_title_sold']}
            onChange={this.onChangForm.bind(this, 'ru', 'meta_title_sold')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="META description sold"
            value={values['ru']['meta_description_sold']}
            onChange={this.onChangForm.bind(this, 'ru', 'meta_description_sold')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="META keywords sold"
            value={values['ru']['meta_keywords_sold']}
            onChange={this.onChangForm.bind(this, 'ru', 'meta_keywords_sold')}
          />
        </Grid>

        {/* EN */}
        <Grid item xs={12}>
          <Grid container alignItems="flex-end">
            <Grid item>
              <Chip label="EN"/>
            </Grid>
            <Grid item sx={{flex: 1}}>
              <Divider sx={{borderBottomWidth: "2px", borderColor: "rgba(0,0,0,0.08)"}}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Title"
            value={values['en']['meta_title']}
            onChange={this.onChangForm.bind(this, 'en', 'meta_title')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Keywords"
            value={values['en']['meta_keywords']}
            onChange={this.onChangForm.bind(this, 'en', 'meta_keywords')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Description"
            value={values['en']['meta_description']}
            onChange={this.onChangForm.bind(this, 'en', 'meta_description')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO text short"
            value={values['en']['seo_text_short']}
            onChange={this.onChangForm.bind(this, 'en', 'seo_text_short')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO text full"
            value={values['en']['seo_text_full']}
            onChange={this.onChangForm.bind(this, 'en', 'seo_text_full')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="META title sold"
            value={values['en']['meta_title_sold']}
            onChange={this.onChangForm.bind(this, 'en', 'meta_title_sold')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="META description sold"
            value={values['en']['meta_description_sold']}
            onChange={this.onChangForm.bind(this, 'en', 'meta_description_sold')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="META keywords sold"
            value={values['en']['meta_keywords_sold']}
            onChange={this.onChangForm.bind(this, 'en', 'meta_keywords_sold')}
          />
        </Grid>

        {/* KAZ */}
        <Grid item xs={12}>
          <Grid container alignItems="flex-end">
            <Grid item>
              <Chip label="KAZ"/>
            </Grid>
            <Grid item sx={{flex: 1}}>
              <Divider sx={{borderBottomWidth: "2px", borderColor: "rgba(0,0,0,0.08)"}}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Title"
            value={values['kaz']['meta_title']}
            onChange={this.onChangForm.bind(this, 'kaz', 'meta_title')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Keywords"
            value={values['kaz']['meta_keywords']}
            onChange={this.onChangForm.bind(this, 'kaz', 'meta_keywords')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Description"
            value={values['kaz']['meta_description']}
            onChange={this.onChangForm.bind(this, 'kaz', 'meta_description')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO text short"
            value={values['kaz']['seo_text_short']}
            onChange={this.onChangForm.bind(this, 'kaz', 'seo_text_short')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO text full"
            value={values['kaz']['seo_text_full']}
            onChange={this.onChangForm.bind(this, 'kaz', 'seo_text_full')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="META title sold"
            value={values['kaz']['meta_title_sold']}
            onChange={this.onChangForm.bind(this, 'kaz', 'meta_title_sold')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="META description sold"
            value={values['kaz']['meta_description_sold']}
            onChange={this.onChangForm.bind(this, 'kaz', 'meta_description_sold')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="META keywords sold"
            value={values['kaz']['meta_keywords_sold']}
            onChange={this.onChangForm.bind(this, 'kaz', 'meta_keywords_sold')}
          />
        </Grid>

      </Grid>
    )
  }
}

export default SeoMeta
